module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1700.359a0d02.svg";